const API_BASE_URL = "https://marketluz.com/laravel8/public/api";

export const getVendorProducts = async (userId) => {
  try {
    const token = localStorage.getItem("token"); // 👈 si usas JWT guardado al hacer login

    const response = await fetch(`${API_BASE_URL}/products/${userId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        ...(token && { Authorization: `Bearer ${token}` }), // 👈 solo agrega si existe token
      },
      credentials: "include", // 👈 si usas cookies de sesión de Laravel
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.warn("⚠️ Get failed:", errorText.slice(0, 200));
      return { message: "get failed" };
    }

    const data = await response.json();
    console.log("✅ data right after fetch:", data);
    return data;
  } catch (error) {
    console.error("❌ Error in getVendorProducts:", error);
    throw error;
  }
};

export const updateVendorProduct = async (productId, updatedData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/producto/actualizar`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        product_id: productId,
        price: updatedData.price,
        Image: updatedData.Image, // required by backend
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      console.warn('Update failed:', data);
      return { success: false, message: data?.message || 'Error updating product' };
    }

    return { success: true, data };
  } catch (error) {
    console.error('Error updating vendor product:', error);
    return { success: false, message: error.message };
  }
};
